import { combineReducers } from "redux";

function dataLoadReducer(state = null, action) {
  if (action.type === "DATA_LOADED") {
    return { ...state, data: action.data };
  } else return state;
}
function loginSuccesReducer(state = null, action) {
  if (action.type === "LOGIN_SUCCESS") {
    return { ...state, data: action.data };
  } else return state;
}
// function logoutSuccesReducer(state = null, action) {
//   if (action.type === "LOGOUT_SUCCESS") {
//     return { ...state, data: action.data };
//   } else return state;
// }
function dataUpdateReducer(state = {}, action) {
  if (action.type === "DATA_UPDATED") {
    console.log(action.type);
    return { ...state, data: action.data };
  } else return state;
}
const  rootReducer = combineReducers({
  dataLoadReducer: dataLoadReducer,
  dataUpdateReducer: dataUpdateReducer,
  loginSuccesReducer:loginSuccesReducer
 
});
export default rootReducer;
